import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"
import useSidebarVisibility from "@/hooks/use-sidebar-visibility"
import CosmosSelector from "@/modules/cosmos/components/cosmos-selector"

export default function Header() {
  const { isVisible } = useSidebarVisibility()

  return (
    <header className="flex h-16 shrink-0 items-center justify-between gap-2 pr-8">
      <div className="flex items-center gap-2 px-4">
        {isVisible && <SidebarTrigger className="ml-1" />}
        <Separator orientation="vertical" className="mr-2 h-4" />
      </div>
      <div>
        <CosmosSelector />
      </div>
    </header>
  )
}
